






















import {Component, Prop, Vue} from "vue-property-decorator";
import OverViewTable from "@/valchrom/views/dataset/OverViewTable.vue";
import JsonViewer from 'vue-json-viewer'
import {Getter} from "vuex-class";

@Component({
    components: {OverViewTable, JsonViewer},
})


export default class SeriesTabs extends Vue {
    name = 'SeriesTabs'
    @Prop() series !: any;
    @Getter overview_simplify !: boolean;
}
